import { useQuery } from '@tanstack/react-query';
import axiosInstance from '@/dataProvider/axios';
import { useAuthStoreV1 } from '@/stores/authStore_v1';
import { ORG_USAGE_SERVICE_REPORT_ENDPOINT } from '@/services/org-admin';
import type { OrgServiceUsageReport, UsageWindowDays } from '@/services/org-admin';

// Admin-only upstream (403 for a plain member) — callers must pass `enabled: false`
// for non-admins rather than relying on this hook to know the caller's role.
export function useOrgUsageServiceReport(days: UsageWindowDays, options?: { enabled?: boolean }) {
  const orgId = useAuthStoreV1((s) => s.selectedOrg?.id ?? null);

  return useQuery({
    queryKey: ['org-usage-service-report', orgId, days],
    queryFn: async () => {
      const { data } = await axiosInstance.get<OrgServiceUsageReport>(ORG_USAGE_SERVICE_REPORT_ENDPOINT(orgId!, days));
      return data;
    },
    enabled: !!orgId && (options?.enabled ?? true),
    // Cached data still shows instantly on mount, but every visit to the Usage
    // tab re-fetches regardless of the global 1-minute staleTime — admins land
    // here specifically to check current spend/budget health.
    refetchOnMount: 'always',
  });
}
